import { render, staticRenderFns } from "./BigMap.vue?vue&type=template&id=240752a9"
import script from "./BigMap.vue?vue&type=script&lang=js"
export * from "./BigMap.vue?vue&type=script&lang=js"
import style0 from "./BigMap.vue?vue&type=style&index=0&id=240752a9&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240752a9')) {
      api.createRecord('240752a9', component.options)
    } else {
      api.reload('240752a9', component.options)
    }
    module.hot.accept("./BigMap.vue?vue&type=template&id=240752a9", function () {
      api.rerender('240752a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/BigMap.vue"
export default component.exports